import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TableIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='25'
			viewBox='0 0 24 25'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M18.75 21.5273H5.25C5.05109 21.5273 4.86032 21.4483 4.71967 21.3077C4.57902 21.167 4.5 20.9763 4.5 20.7773V4.27734C4.5 4.07843 4.57902 3.88767 4.71967 3.74701C4.86032 3.60636 5.05109 3.52734 5.25 3.52734H14.25L19.5 8.77734V20.7773C19.5 20.9763 19.421 21.167 19.2803 21.3077C19.1397 21.4483 18.9489 21.5273 18.75 21.5273Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.25 3.52734V8.77734H19.5'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9 13.2773H15'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9 16.2773H15'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default TableIcon;
